import i18next from 'i18next';
import {initReactI18next} from 'react-i18next';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';

const savedLng = localStorage.getItem('i18nextLng');

i18next
  .use(initReactI18next)
  .use(I18nextBrowserLanguageDetector)
  .init({
    fallbackLng: 'de',
    supportedLngs: ['de', 'en'],
    resources: {
      en: {
        translation: {
          apply: 'Apply',
          company_size: {
            Klein: 'Small',
            Mittel: 'Medium',
            Groß: 'Large'
          },
          privacy_policy: {
            title: 'Privacy Policy',
            content: 'Your privacy policy text goes here.'
          },
          legal_notice: {
            title: 'Legal Notice',
            content: 'Your legal notice text goes here.',
          },
          filters: {
            field_name_language: 'Language',
            field_name_search: 'Company name',
            field_name_search_not_found: 'Nothing found',
            field_name_products_and_services: 'Products & Services',
            field_name_fields_and_profiles: 'Career Fields & Skill Profiles',
            field_name_technologies: 'Technologies & Innovations',
            field_name_industrie_type: 'Industry',
            field_name_company_size: 'Company sizes',
            field_name_company_type: 'Legal forms',
            show_more: 'More',
            search_placeholder: 'Search'
          },
          site_title: 'Industrial Map of Saarland',
          button_register_your_company: 'Register',
          button_login: 'Login',
          button_privacy_policy: 'Privacy Policy',
          button_legal_notice: 'Legal Notice',
          popup: {
            company_type: 'Legal form',
            type_of_industry: 'Industries',
            field_profiles: 'Career Fields & Skill Profiles',
            company_size: 'Company size',

            products_and_services: 'Products & Services',
            technologies: 'Technologies & Innovations',

            address: 'Address',
            email: 'Email',
            website: 'Website',
            contact_information: 'Contact information',
            apply: 'Apply'
          },
          sign_up: {
            salutation: 'Salutation',
            select_placeholder: 'Please select',
            salutation_herr: 'Mr.',
            salutation_frau: 'Ms.',
            salutation_divers: 'Non-binary / Other',
            firstName: 'First Name',
            lastName: 'Last Name',
            email: 'Email',
            company: 'Company',
            newsletter: 'I agree to receive the newsletter and accept the privacy policy.',
            dataProcessingPrefix: 'I agree to the processing of my personal data in accordance with the ',
            dataProcessingLinkText: 'privacy policy',
            dataProcessingSuffix: '.',
            submit: 'Submit',
            title: 'Sign Up',
            subtitle: 'Please fill in your details below.',
            success: 'Your request was submitted successfully.',
            error: {
              required: 'Please fill in all required fields.',
              submit: 'There was an error submitting your request. Please try again.',
              invalidEmail: 'Please enter a valid email address.',
              emailExists: 'A user with this email already exists.',
              companyExists: 'A company with this name is already registered.'
            }
          },
          login: {
            title: 'Login',
            email: 'Email',
            password: 'Password',
            submit: 'Login',
            forgot: 'Forgot your password?',
            error: {
              invalid: 'Invalid email or password. Please try again.'
            }
          },
          forgot: {
            title: 'Forgot password?',
            subtitle: 'Enter your email address and we’ll send you a password reset link.',
            email: 'Email address',
            submit: 'Reset password',
            success: 'If an account with this email exists, a password reset link has been sent.',
            error: {
              required: 'Please enter your email address.',
              failed: 'Failed to send the reset email. Please try again later.'
            }
          },
          reset: {
            title: 'Set your new password',
            subtitle: 'Enter and confirm your new password.',
            password: 'New password',
            confirm: 'Confirm password',
            submit: 'Save password',
            success: 'Your password has been successfully reset.',
            error: {
              required: 'Please fill out both fields.',
              mismatch: 'Passwords do not match.',
              failed: 'Failed to reset password. Please try again.',
              weakPassword: 'Password must be at least 6 characters long and contain at least one uppercase letter, one lowercase letter, and one digit.'
            }
          },
          edit_profile: {
            title: 'Edit Profile',
            subtitle: 'You can update your personal information.',
            salutation: 'Salutation',
            salutation_herr: 'Mr',
            salutation_frau: 'Ms',
            salutation_divers: 'Other',
            select_placeholder: 'Not specified',
            firstName: 'First Name',
            lastName: 'Last Name',
            email: 'Email',
            company: 'Company',
            newPassword: 'New Password',
            confirmPassword: 'Confirm Password',
            newsletter: 'I want to subscribe to the newsletter',
            submit: 'Save',
            success: 'Profile updated successfully.',
            error: {
              required: 'Please fill in all required fields.',
              invalidEmail: 'Invalid email address.',
              passwordMismatch: 'Passwords do not match.',
              submit: 'An error occurred while saving.',
              fetch: 'Error loading user data.',
            },
            logout: 'Logout'
          },
          company_form: {
            company: 'Company',
            branch: 'Branch / Location',
            street: 'Street and House Number',
            zip: 'ZIP Code',
            location: 'Location',
            email: 'Email',
            website: 'Website',
            website_career: 'Career Page',
            contact: 'Contact Information',
            company_type: 'Legal form',
            company_size: 'Company Size',
            size_overview: 'Company Size Overview',
            size: 'Size',
            employees: 'Employees',
            revenue: 'Revenue',
            balance: 'Balance',
            size_small: 'Small',
            employees_small: 'up to 49',
            revenue_small: 'up to 10M',
            balance_small: 'up to 10M',
            size_medium: 'Medium',
            employees_medium: 'up to 249',
            revenue_medium: 'up to 50M',
            balance_medium: 'up to 43M',
            size_large: 'Large',
            employees_large: '250 and more',
            revenue_large: 'more than 51M',
            balance_large: 'more than 44M',
            latitude: 'Latitude',
            longitude: 'Longitude',
            technologies: 'Technologies & Innovations',
            type_of_industries: 'Industries',
            product_services: 'Products & Services',
            field_profiles: 'Career Fields & Skill Profiles',
            saving: 'Saving...',
            status: {
              published: 'Approved',
              draft: 'In review'
            },
            success: 'Company entry saved successfully.',
            validation_error: 'Please fill in all required fields.',
            error: 'An error occurred while saving.',
            title: 'Branches / Locations',
            no_objects: 'No branches yet. Click "Add Branch / Location" to create your first one.',
            add_object: 'Branch / Location',
            save: 'Save',
            saarlandwarning: 'The selected location is outside of Saarland.'
          },
          email_confirmed: {
            title: 'Email Confirmed',
            subtitle: 'Thank you! Your email address has been successfully confirmed.',
            instructions: 'You will shortly receive a message with instructions to set your password. You can now close this page.'
          },
          language: {
            label: 'Select language'
          },
          languages: {
            de: 'German',
            en: 'English'
          }
        }
      },
      de: {
        translation: {
          apply: 'Bewerben',
          company_size: {
            Klein: 'Klein',
            Mittel: 'Mittel',
            Groß: 'Groß'
          },
          privacy_policy: {
            title: 'Datenschutzerklärung',
            content: 'Hier steht Ihre Datenschutzerklärung.'
          },
          legal_notice: {
            title: 'Impressum',
            content: 'Hier steht Ihr Impressum.',
          },
          filters: {
            field_name_language: 'Sprache',
            field_name_search: 'Unternehmensname',
            field_name_search_not_found: 'Nichts gefunden',
            field_name_products_and_services: 'Produkte & Dienstleistungen',
            field_name_fields_and_profiles: 'Berufsfelder & Kompetenzprofile',
            field_name_technologies: 'Technologien & Innovationen',
            field_name_industrie_type: 'Branchen',
            field_name_company_size: 'Größe des Unternehmens',
            field_name_company_type: 'Rechtsformen',
            show_more: 'Mehr',
            search_placeholder: 'Suche'
          },
          site_title: 'Industrielandkarte des Saarlandes',
          button_register_your_company: 'Registrieren',
          button_login: 'Login',
          button_privacy_policy: 'Datenschutz',
          button_legal_notice: 'Impressum',
          popup: {
            company_type: 'Rechtsform',
            type_of_industry: 'Branchen',
            field_profiles: 'Berufsfelder & Kompetenzprofile',
            company_size: 'Unternehmensgröße',

            products_and_services: 'Produkte & Dienstleistungen',
            technologies: 'Technologien & Innovationen',

            address: 'Adresse',
            email: 'E-Mail',
            website: 'Website',
            contact_information: 'Kontaktinformationen',
            apply: 'Bewerben'
          },
          sign_up: {
            salutation: 'Anrede',
            select_placeholder: 'Bitte auswählen',
            salutation_herr: 'Herr',
            salutation_frau: 'Frau',
            salutation_divers: 'Divers',
            firstName: 'Vorname',
            lastName: 'Nachname',
            email: 'E-Mail',
            company: 'Firma',
            newsletter: 'Ich stimme dem Erhalt des Newsletters und der Datenschutzrichtlinie zu.',
            dataProcessingPrefix: 'Ich stimme der Verarbeitung meiner personenbezogenen Daten gemäß der ',
            dataProcessingLinkText: 'Datenschutzrichtlinie',
            dataProcessingSuffix: ' zu.',
            submit: 'Absenden',
            title: 'Registrierung',
            subtitle: 'Bitte füllen Sie die folgenden Angaben aus.',
            success: 'Ihre Anfrage wurde erfolgreich übermittelt.',
            error: {
              required: 'Bitte füllen Sie alle Pflichtfelder aus.',
              submit: 'Beim Absenden der Anfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
              invalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
              emailExists: 'Ein Benutzer mit dieser E-Mail-Adresse ist bereits registriert.',
              companyExists: 'Ein Unternehmen mit diesem Namen ist bereits registriert.'
            }
          },
          login: {
            title: 'Anmeldung',
            email: 'E-Mail',
            password: 'Passwort',
            submit: 'Anmelden',
            forgot: 'Passwort vergessen?',
            error: {
              invalid: 'Ungültige E-Mail oder ungültiges Passwort. Bitte versuchen Sie es erneut.'
            }
          },
          forgot: {
            title: 'Passwort vergessen?',
            subtitle: 'Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen des Passworts.',
            email: 'E-Mail-Adresse',
            submit: 'Passwort zurücksetzen',
            success: 'Wenn ein Konto mit dieser E-Mail-Adresse existiert, wurde eine E-Mail zum Zurücksetzen des Passworts gesendet.',
            error: {
              required: 'Bitte geben Sie Ihre E-Mail-Adresse ein.',
              failed: 'Fehler beim Senden der E-Mail. Bitte versuchen Sie es später erneut.'
            }
          },
          reset: {
            title: 'Neues Passwort festlegen',
            subtitle: 'Geben Sie ein neues Passwort ein und bestätigen Sie es.',
            password: 'Neues Passwort',
            confirm: 'Passwort bestätigen',
            submit: 'Passwort speichern',
            success: 'Ihr Passwort wurde erfolgreich zurückgesetzt.',
            error: {
              required: 'Bitte füllen Sie beide Felder aus.',
              mismatch: 'Passwörter stimmen nicht überein.',
              failed: 'Fehler beim Zurücksetzen des Passworts. Bitte versuchen Sie es erneut.',
              weakPassword: 'Das Passwort muss mindestens 6 Zeichen lang sein und mindestens einen Großbuchstaben, einen Kleinbuchstaben und eine Ziffer enthalten.'
            }
          },
          edit_profile: {
            title: 'Profil bearbeiten',
            subtitle: 'Sie können Ihre persönlichen Daten aktualisieren',
            salutation: 'Anrede',
            salutation_herr: 'Herr',
            salutation_frau: 'Frau',
            salutation_divers: 'Divers',
            select_placeholder: 'Keine Angabe',
            firstName: 'Vorname',
            lastName: 'Nachname',
            email: 'E-Mail',
            company: 'Firma',
            newPassword: 'Neues Passwort',
            confirmPassword: 'Passwort bestätigen',
            newsletter: 'Ich möchte den Newsletter abonnieren',
            submit: 'Speichern',
            success: 'Profil wurde erfolgreich aktualisiert.',
            error: {
              required: 'Bitte füllen Sie alle erforderlichen Felder aus.',
              invalidEmail: 'Ungültige E-Mail-Adresse.',
              passwordMismatch: 'Passwörter stimmen nicht überein.',
              submit: 'Beim Speichern ist ein Fehler aufgetreten.',
              fetch: 'Fehler beim Laden der Benutzerdaten.',
            },
            logout: 'Abmelden'
          },
          company_form: {
            company: 'Unternehmen',
            branch: 'Standort / Filiale',
            street: 'Straße und Hausnummer',
            zip: 'PLZ',
            location: 'Ort',
            email: 'E-Mail',
            website: 'Webseite',
            website_career: 'Karriereseite',
            contact: 'Kontaktinformationen',
            company_type: 'Rechtsform',
            company_size: 'Unternehmensgröße',
            size_overview: 'Übersicht Unternehmensgröße',
            size: 'Größe',
            employees: 'Mitarbeiter',
            revenue: 'Umsatz',
            balance: 'Bilanz',
            size_small: 'klein',
            employees_small: 'bis 49',
            revenue_small: 'bis 10 Mio',
            balance_small: 'bis 10 Mio',
            size_medium: 'mittel',
            employees_medium: 'bis 249',
            revenue_medium: 'bis 50 Mio',
            balance_medium: 'bis 43 Mio',
            size_large: 'groß',
            employees_large: 'ab 250',
            revenue_large: 'ab 51 Mio',
            balance_large: 'ab 44 Mio',
            latitude: 'Breitengrad',
            longitude: 'Längengrad',
            technologies: 'Technologien & Innovationen',
            type_of_industries: 'Branchen',
            product_services: 'Produkte & Dienstleistungen',
            field_profiles: 'Berufsfelder & Kompetenzprofile',
            saving: 'Speichern...',
            status: {
              published: 'Genehmigt',
              draft: 'In Prüfung'
            },
            success: 'Standort wurde erfolgreich gespeichert.',
            validation_error: 'Bitte füllen Sie alle Pflichtfelder aus.',
            title: 'Standorte / Filialen',
            no_objects: 'Noch keine Standorte vorhanden. Klicken Sie auf „Standort / Filiale hinzufügen”, um Ihren ersten Standort zu erstellen.',
            add_object: 'Standort / Filiale hinzufügen',
            save: 'Speichern',
            saarlandwarning: 'Die ausgewählte Position liegt außerhalb des Saarlandes.',
            error: 'Beim Speichern ist ein Fehler aufgetreten.'
          },
          email_confirmed: {
            title: 'E-Mail bestätigt',
            subtitle: 'Vielen Dank! Ihre E-Mail-Adresse wurde erfolgreich bestätigt.',
            instructions: 'In Kürze erhalten Sie eine Nachricht mit Anweisungen zum Setzen Ihres Passworts. Sie können diese Seite jetzt schließen.'
          },
          language: {
            label: 'Sprache auswählen'
          },
          languages: {
            de: 'Deutsch',
            en: 'Englisch'
          }
        }
      }
    }
  })
  .then(() => {
    if (!savedLng) {
      i18next.changeLanguage('de');
    }
  });
